export const styles = {
  global: {
    body: {
      bg: 'white',
      _dark: { bg: 'gray.800' },
      transition: 'background-color 0.2s',
      lineHeight: 'base',
      fontDisplay: 'swap',
      fontWeight: '500',
    },
  },
}
